import _ticky from "ticky";
var exports = {};
var ticky = _ticky;

exports = function debounce(fn, args, ctx) {
  if (!fn) {
    return;
  }

  ticky(function run() {
    fn.apply(ctx || null, args || []);
  });
};

export default exports;